// libs
import { useDispatch } from 'react-redux'
import { useLazyQuery } from '@apollo/client/react'
// graphql
import { RISK_TEMPLATE_QUERY, RISK_VIEWS_QUERY } from 'graphql/risk/queries'
// types
import { IRiskTemplate, IRiskView } from 'types/graphql'
// redux
import { setRiskViews as setRiskViewsAction, setRiskViewsLoading } from 'store/reducers/riskViews'
import { setRiskTemplates as setRiskTemplatesAction, setRiskTemplatesLoading } from 'store/reducers/riskTemplates'
// utils
import get from 'lodash/get'
import { handleError } from 'utils/errors/handlers'

export const useRiskModuleData = () => {
  const dispatch = useDispatch()

  const [getRiskViews] = useLazyQuery(RISK_VIEWS_QUERY, { fetchPolicy: 'no-cache' })
  const [getRiskTemplates] = useLazyQuery(RISK_TEMPLATE_QUERY, { fetchPolicy: 'no-cache' })

  const setRiskViews = async () => {
    try {
      dispatch(setRiskViewsLoading(true))

      const data = await getRiskViews({
        variables: { pagination: { pageTake: 1000, pageSkip: 0 }, filter: { isLinkedView: false } }
      })

      const riskViews = get(data, 'data.riskViews.data', []) as IRiskView[]

      dispatch(setRiskViewsAction(riskViews))
    } catch (e) {
      handleError(e, 'useSetRiskTemplates.setRiskViews')
    } finally {
      dispatch(setRiskViewsLoading(false))
    }
  }

  const setRiskTemplates = async () => {
    try {
      dispatch(setRiskTemplatesLoading(true))

      const data = await getRiskTemplates({
        variables: { pagination: { pageTake: 1000, pageSkip: 0 } }
      })

      const riskTemplates = get(data, 'data.riskTemplates.data', []) as IRiskTemplate[]

      dispatch(setRiskTemplatesAction(riskTemplates))
    } catch (e) {
      handleError(e, 'useSetRiskTemplates.setRiskTemplates')
    } finally {
      dispatch(setRiskTemplatesLoading(false))
    }
  }

  return {
    setRiskViews,
    setRiskTemplates
  }
}
